import { SB } from './storybook-ui'

export type Toast = {
  id: string
  message: string
  type?: 'default' | 'success' | 'error' | 'warning'
}

type ToasterProps = {
  toasts: Toast[]
  onDismiss: (id: string) => void
}

export function Toaster({ toasts, onDismiss }: ToasterProps) {
  return (
    <div className="fixed right-4 bottom-4 z-50 flex flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={SB.cn(
            'flex items-center justify-between rounded-md px-4 py-3 shadow-lg transition-all duration-300 animate-in fade-in slide-in-from-bottom-5',
            {
              'bg-surface-1 text-on-surface border border-border':
                toast.type === 'default',
              'bg-green-600 text-white': toast.type === 'success',
              'bg-red-600 text-white': toast.type === 'error',
              'bg-amber-600 text-white': toast.type === 'warning',
            },
          )}
        >
          <span>{toast.message}</span>
          <button
            onClick={() => {
              onDismiss(toast.id)
            }}
            className="ml-4 rounded-full p-1 hover:bg-black/10"
          >
            <SB.icons.X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  )
}
